module.exports = __webpack_public_path__ + "42fdeb64fc7ae895e6b96bd17cc014da.png";